export default {
  close: 'Close Chat Popup',
};
